import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "avatar-dropdown"
};
import { useUserStore } from '@/store/modules/user';
import { toLoginRoute } from '@/utils/routes';
import { translate } from '@/i18n';
import { createStatic } from '~/library/plugins/modal.helper';
import UpdatePassword from './UpdatePassword.vue';

import { useRoute, useRouter } from 'vue-router';
import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/index';
import 'element-plus/es/components/message/style/index';
const size = 40;
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const user = ref({});
    const userStore = useUserStore();
    const {
      avatar,
      linkSurname
    } = storeToRefs(userStore);
    const {
      logout
    } = userStore;
    const active = ref(false);
    const handleVisibleChange = val => {
      active.value = val;
    };
    const handleCommand = async command => {
      switch (command) {
        case 'logout':
          await router.push(toLoginRoute(route.fullPath));
          await logout();
          break;
        case 'personalCenter':
          createStatic(UpdatePassword).then(async res => {
            console.log('修改密码成功');
            ElMessage.success('修改成功, 请重新登录');
            setTimeout(async () => {
              await logout();
            }, 1500);
          });
          // await router.push('/setting/personalCenter')
          break;
      }
    };
    // 获取显示文本
    const displayText = computed(() => {
      if (!user.value.linkSurname) return '';
      const trimmedName = user.value.linkSurname.trim();
      // 判断是否为中文（简单判断：是否包含中文字符）
      const isChinese = /[\u4e00-\u9fa5]/.test(trimmedName);
      if (isChinese) {
        // 中文取第一个字
        return trimmedName.charAt(0);
      } else {
        // 英文取第一个词的首字母
        const firstWord = trimmedName.split(/\s+/)[0];
        return firstWord.charAt(0).toUpperCase();
      }
    });
    // 计算头像样式
    const avatarStyle = computed(() => {
      return {
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${size * 0.4}px`,
        lineHeight: `${size}px`
      };
    });
    // 根据名字生成一致的颜色索引
    onMounted(() => {
      try {
        user.value = JSON.parse(sessionStorage.getItem('user'));
      } catch (e) {}
    });
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createBlock(_component_el_dropdown, {
        onCommand: handleCommand,
        onVisibleChange: handleVisibleChange
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "personalCenter"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "user-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('修改密码')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "logout"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "logout-circle-r-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('退出登录')), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createElementVNode("div", {
          class: "dynamic-avatar",
          style: _normalizeStyle(_unref(avatarStyle))
        }, _toDisplayString(_unref(displayText)), 5), _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "user-name"
        }, null, -1))])]),
        _: 1
      });
    };
  }
});